<template>
  <div class="cont">
    <!--<div class="navTitle">当前位置：益书宝页面 > 回收站</div>-->
    <div class="bgcBox">
      <div class="fanh">
        <button @click="goto">返回</button>
      </div>
      <div class="titleBox">
        <div class="tabBox">
          <span class="bgc" @click="delAll">一键清空</span>
          <span @click="huanY">还原</span>
          <span @click="del">删除</span>
          <!--        <span :class="{bgc:spanNum === 1}" @click="spanNum = 1">一键清空</span>-->
          <!--        <span :class="{bgc:spanNum === 2}" @click="spanNum = 2">还原</span>-->
          <!--        <span :class="{bgc:spanNum === 3}" @click="spanNum = 3">删除</span>-->
        </div>
        <div class="searchBox">
          <input type="text" v-model="search" placeholder="请输入你要搜索的内容">
          <div class="btn" @click="keyWord">搜索</div>
        </div>
      </div>
      <div class="listBox">
        <div class="tabelTitle">
          <div class="titleLeft">
            <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange"></el-checkbox>
            全部文档
          </div>
          <div class="titleRight">
            <div class="titleRightCenOne">
              时间
            </div>
          </div>
        </div>
        <div class="tabelBox" v-for="item in list" :key="item.id">
          <div style="display: flex;justify-content: flex-start;">
            <el-checkbox-group v-model="checkedCities" @change="handleCheckedCitiesChange">
              <el-checkbox :label="item.id" :key="item.type" class="tabelBoxTitleLeft">
              <span style="margin-left: 34px; font-size: 16px;">
                {{item.title}}
              </span>
              </el-checkbox>
            </el-checkbox-group>

          </div>
          <div class="tabelBoxTitleRight">
            <div class="tabelBoxTitleRightCenOne">
              {{item.addtime}}
            </div>
          </div>
        </div>
        <div class="pageBox">
          <!--<span>首页</span>-->
          <el-pagination
                  background
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page.sync="page.pageNum"
                  :page-size="page.pageSize"
                  layout="prev, pager, next"
                  :total="page.pageTotal">
          </el-pagination>
          <!--<span>尾页</span>-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "hszBanKuai",
    data() {
      return {
        checkAll: false,
        spanNum: 1, // tab切换背景
        checkedCities: [], //  选中的
        isIndeterminate: false,
        list: [],
        search:'',
        page: {
          pageNum: 1,
          pageSize: 5,
          pageTotal: 1
        }
      }
    },
    computed: {
      user() {
        return this.$store.state.user
      }
    },
    created() {
      if(!this.user){
        this.$router.push("/login")
      }
      this.$emit('setIsAct', 7)
      this.getList()
    },
    methods: {
      // 获取列表
      getList() {
        if (this.$route.query.key) {
          this.search = this.$route.query.key
        } else {
          this.search = ''
        }
        if (this.$route.query.pageNum) {
          this.page.pageNum = Number(this.$route.query.pageNum)
        } else {
          this.page.pageNum = 1
        }
        this.$api.apiAdmin.GetRecycleBin({
          mid: this.user.mid,
          keyword: this.search,
          page: this.page.pageNum,
          pagesize: this.page.pageSize
        }).then(res => {
          console.log(res)
          this.list = res.data.data
          let List = res.data.data
          List.map(item => {
            item.addtime = this.$tools.ZHDate(new Date(item.addtime * 1000), 3)
          })
          this.page.pageTotal = res.data.pageinfo.count
          // this.page.pageCount = Math.ceil(Number(res.data.pageinfo.count) / Number(this.page.pageSize))
        }).catch(res => {
          this.$messageError(res.msg);
        })
      },
      // 删除
      del() {
        if(this.checkedCities.length < 1) {
          this.$messageError('请选择文件')
          return false
        }
        var ary = []
        this.checkedCities.map(item => {
          this.list.map(items => {
            if(item === items.id){
              ary.push({id:items.id,type:items.type})
            }
          })
        })
        this.$confirm('<p style="color: #0a2240;margin: 30px 0; ">你确定要删除吗?</p>', '温馨提示', {
          dangerouslyUseHTMLString:true,
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: '',
          center: true,
          roundButton:true,
          cancelButtonClass:"scqx",
          confirmButtonClass:"scqd",
        }).then(() => {
          this.$api.apiAdmin.RecycleBinDo({
            mid: this.user.mid,
            kind: 2,
            idarr: ary
          }).then(res => {
            this.$messageSuccess(res.msg);
            // 获取列表
            this.getList()
            this.checkedCities = []
          }).catch(res => {
            this.$messageError(res.msg);
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      },
      // 还原
      huanY(){
        if(this.checkedCities.length < 1) {
          this.$messageError('请选择文件')
          return false
        }
        var ary = []
        this.checkedCities.map(item => {
          this.list.map(items => {
            if(item === items.id){
              ary.push({id:items.id,type:items.type})
            }
          })
        })
        this.$api.apiAdmin.RecycleBinDo({
          mid: this.user.mid,
          kind: 1,
          idarr: ary
        }).then(res => {
          this.$messageSuccess(res.msg);
          // 获取列表
          this.getList()
          this.checkedCities = []
        }).catch(res => {
          this.$messageError(res.msg);
        })
      },
      // 一键清空
      delAll(){
        if(this.list.length < 1){
          this.$messageError('回收站无文件！')
          return false
        }
        this.$confirm('<p style="color: #0a2240;margin: 30px 0; ">你确定要清空吗?</p>', '温馨提示', {
          dangerouslyUseHTMLString:true,
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: '',
          center: true,
          roundButton:true,
          cancelButtonClass:"scqx",
          confirmButtonClass:"scqd",
        }).then(() => {
          this.$api.apiAdmin.RecycleBinDo({
            mid: this.user.mid,
            kind: 3
          }).then(res => {
            this.$messageSuccess(res.msg);
            // 获取列表
            this.getList()
            this.checkedCities = []
          }).catch(res => {
            this.$messageError(res.msg);
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          });
        });
      },
      //
      goto(){
        this.$router.push('/home/wdwzBanKuai')
      },
      // 搜索
      keyWord(){
        this.setPath()
      },
      // 点击分页
      handleSizeChange(num) {
        this.page.pageNum = num
      },
      // 选择页数
      handleCurrentChange(num) {
        this.page.pageNum = num
      },
      // 修改路径
      setPath(){
        this.$router.push({
          path:'/home/hszBanKuai',
          query: {
            key: this.search,
            pageNum: this.page.pageNum,
          }
        })
      },
      handleCheckAllChange(val) {
        var data = this.list
        var ary = []
        data.map(item => {
          ary.push(item.id)
        })
        this.checkedCities = val ? ary : [];
        this.isIndeterminate = false;
        console.log(this.checkedCities)
      },
      handleCheckedCitiesChange(value) {
        console.log(value)
        let checkedCount = value.length;
        this.checkAll = checkedCount === this.list.length;
        this.isIndeterminate = checkedCount > 0 && checkedCount < this.list.length;
      }
    },
    watch: {
      $route(){
        this.getList()
      },
      'page.pageNum'() {
        this.setPath()
      },
    }
  }
</script>

<style scoped lang="scss">
  .bgc {
    background-color: #0a2240 !important;
    color: #ffffff !important;
  }

  .cont {
    width: 1220px;
    margin: 0 auto;
    padding-bottom: 50px;
    .navTitle {
      width: 100%;
      height: 40px;
      line-height: 40px;
      color: #ffffff;
      font-size: 14px;
    }
    .bgcBox {
      width: 100%;
      min-height: 800px;
      padding: 30px;
      background-color: #fff;
      .fanh {
        width: 100%;
        text-align: right;
        button {
          width: 70px;
          height: 30px;
          text-align: center;
          font-size: 16px;
          color: #ffffff;
          background-color: #0a2240;
          border-radius: 15px;
          line-height: 30px;
          cursor: pointer;
          margin-right: 1px;
        }
      }
      .titleBox {
        display: flex;
        justify-content: space-between;
        padding-top: 20px;
        .tabBox {
          min-width: 300px;
          padding-top: 10px;

          span {
            font-size: 18px;
            font-weight: bold;
            padding: 2px 20px 4px 20px;
            margin-right: 10px;
            cursor: pointer;
            border-radius: 16px;
            color: #0a2240;
            border: 1px solid #0a2240;
          }
        }

        .searchBox {
          position: relative;

          input {
            width: 573px;
            height: 40px;
            background-color: #f8f3f3;
            border-radius: 24px;
            border: none;
            outline: none;
            text-indent: 20px;
            padding-right: 176px;
          }

          .btn {
            width: 135px;
            height: 40px;
            background: #0a2240 url('../../../assets/images/sousuo.png') no-repeat;
            background-size: 20px 19px;
            background-position-x: 30px;
            background-position-y: 11px;
            box-shadow: -6px 6px 18px 0px rgba(170,208,255,.45);
            border-radius: 24px;
            font-size: 18px;
            color: #fff;
            line-height: 40px;
            padding-left: 60px;
            position: absolute;
            top: 0;
            right: 0;
            cursor: pointer;
          }
        }
      }

      .listBox {
        margin-top: 60px;
        height: 100%;

        .tabelTitle {
          width: 100%;
          display: flex;
          justify-content: space-between;
          border-bottom: 1px solid #ebebeb;

          .titleLeft {
            min-width: 400px;
            max-height: 600px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            font-size: 16px;
            color: #666;
            line-height: 30px;
          }

          .titleRight {
            display: flex;
            justify-content: space-between;

            .titleRightCenOne {
              font-size: 16px;
              color: #666666;
              line-height: 30px;
              width: 100px;
              text-align: center;
              margin-right: 40px;
            }

            .titleRightCenTwo {
              font-size: 16px;
              color: #666666;
              line-height: 30px;
              width: 150px;
              text-align: center;
            }
          }

        }

        .tabelBox {
          width: 100%;
          display: flex;
          padding: 5px 0;
          justify-content: space-between;
          margin-top: 20px;

          .tabelBoxTitleLeft {
            min-width: 400px;
            max-height: 700px;
            background: url('../../../assets/images/Wicon.png') no-repeat;
            background-position-x: 23px;
            background-position-y: 6px;
            background-size: 22px 22px;
            /*padding-left: 37px;*/
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            font-size: 18px;
            color: #333333;
            line-height: 30px;
            margin-left: 10px;
          }

          .tabelBoxTitleRight {
            display: flex;
            justify-content: space-between;

            .tabelBoxTitleRightCenOne {
              font-size: 14px;
              color: #999;
              line-height: 30px;
              width: 100px;
              text-align: center;
              margin-right: 40px;
            }

            .tabelBoxTitleRightCenTwo {
              font-size: 14px;
              color: #999;
              line-height: 30px;
              width: 150px;
              text-align: center;

              .tabelBtnYl {
                padding: 2px 12px;
                font-size: 16px;
                background-color: #ffd919;
                border-radius: 13px;
                /*margin-right: 30px;*/
                cursor: pointer;
                color: #333333;
              }

              .tabelBtnBj {
                padding: 2px 12px;
                font-size: 16px;
                background-color: #0a2240;
                border-radius: 13px;
                color: #ffffff;
                cursor: pointer;
              }
            }
          }

        }

        .pageBox {
          margin-top: 80px;
          display: flex;
          justify-content: center;

          span {
            padding: 6px 10px;
            border: 1px solid #f2f2f2;
            font-size: 14px;
            color: #666666;
            cursor: pointer;
          }

          .el-pagination {
            .el-pager {
              .active {
                background-color: #0a2240 !important; // 进行修改背景和字体
                color: #fff !important;
              }
            }
          }
        }
      }
    }
  }

</style>
